import { Group, List, ProductUpdate, ValidationResult } from '~/Api/User/ProductGroup/CzReimbursement';

export enum ActionType {
	request = 'CzReimbursement.request',
	receive = 'CzReimbursement.receive',
	requestUpdate = 'CzReimbursement.requestUpdate',
	receiveUpdate = 'CzReimbursement.receiveUpdate',
	scheduleUpdate = 'CzReimbursement.scheduleUpdate',
	requestXlsCreate = 'CzReimbursement.requestXlsCreate',
	receiveXlsCreate = 'CzReimbursement.receiveXlsCreate',
	requestGroup = 'CzReimbursement.requestGroup',
	receiveGroup = 'CzReimbursement.receiveGroup',
	requestGroupUpdate = 'CzReimbursement.requestGroupUpdate',
	receiveGroupUpdate = 'CzReimbursement.receiveGroupUpdate',
	prune = 'CzReimbursement.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.request;
}

export interface ReceiveAction {
	groupId: string;
	czReimbursement: List | null;
	request: Promise<any>;
	type: ActionType.receive;
}

export interface ScheduleUpdateAction {
	groupId: string;
	packageSize: number | null;
	products: ProductUpdate[];
	timeoutId: NodeJS.Timeout;
	type: ActionType.scheduleUpdate;
	dosageStrength: number | null;
	usualTherapeuticDailyDose: number | null;
	usualTherapeuticDailyDosePerPackage: number | null;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	czReimbursement: List | null;
	request: Promise<any>;
	type: ActionType.receiveUpdate;
}

export interface RequestGroupAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestGroup;
}

export interface ReceiveGroupAction {
	groupId: string;
	group: Group | null;
	request: Promise<any>;
	type: ActionType.receiveGroup;
}

export interface RequestGroupUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestGroupUpdate;
}

export interface ReceiveGroupUpdateAction {
	request: Promise<any>;
	type: ActionType.receiveGroupUpdate;
	error: Error | null;
	group: Group | null;
	groupId: string;
}

export interface RequestXlsCreateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestXlsCreate;
}

export interface ReceiveXlsCreateAction {
	request: Promise<any>;
	type: ActionType.receiveXlsCreate;
	validationResult: ValidationResult | null;
}

export interface PruneAction {
	groupId: string;
	type: ActionType.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| RequestGroupAction
	| ReceiveGroupAction
	| RequestGroupUpdateAction
	| ReceiveGroupUpdateAction
	| RequestXlsCreateAction
	| ReceiveXlsCreateAction
	| PruneAction;
